/* Ringora 2030 — shared scroll reveal + small UI helpers */
(function(){
  function initReveal(){
    var els = document.querySelectorAll('.r30-reveal:not(.r30-watched)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('r30-in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('r30-in'); io.unobserve(en.target); } });
    },{threshold:.16});
    els.forEach(function(e){ e.classList.add('r30-watched'); io.observe(e); });
  }
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(initReveal);
  // Re-scan when Shopify theme editor adds/edits sections
  document.addEventListener('shopify:section:load', initReveal);
  window.R30 = { initReveal: initReveal };
})();
